import { NavDropdown } from "react-bootstrap";
import { Currency } from "../../../../types/Currency/Currency";
import StyledNavDropdown from "./StyledNavDropdown";
import CurrencyModal from "../../../modal/Currency/CurrencyModal";
import { useState } from "react";
import { useCurrencyContext } from "../../../../context/Currency/CurrencyContext";
import { useAuthContext } from "../../../auth/AuthContext";
import { useBasketContext } from "../../../../context/Basket/BasketContext";
import { Basket } from "../../../../types/Basket/Basket";
import useBasketService from "../../../../hooks/useBasketService";
import { LocalStorageKeys } from "../../../../types/LocalStorageKeys";
import { clearAutoDetectedCurrency } from "../../../../utils/currencyDetection";

const CurrencySelect = () => {
  const [showCurrencyModal, setShowCurrencyModal] = useState(false);

  const { user } = useAuthContext();
  const { setBasket } = useBasketContext();
  const { selectedCurrency, setSelectedCurrency } = useCurrencyContext();

  const basketService = useBasketService();

  const onCurrencySelect = (currency: Currency) => {
    if (!currency) return;

    if (user) {
      basketService.ChangeCurrency(currency.code).then((b: Basket | null) => {
        setBasket(b);
        setSelectedCurrency(currency);
      });
    } else {
      localStorage.setItem(
        LocalStorageKeys.TRANSACTION_CURRENCY,
        currency.code,
      );
      clearAutoDetectedCurrency();
      setSelectedCurrency(currency);
    }
  };

  return (
    <>
      <StyledNavDropdown
        title={
          <span className="mr-2 text-white">
            ({selectedCurrency?.symbol}) {selectedCurrency?.code}
          </span>
        }
      >
        <NavDropdown.Item onClick={() => setShowCurrencyModal(true)}>
          Change Currency
        </NavDropdown.Item>
      </StyledNavDropdown>
      {showCurrencyModal && (
        <CurrencyModal
          onSelect={onCurrencySelect}
          onHide={() => setShowCurrencyModal(false)}
        />
      )}
    </>
  );
};

export default CurrencySelect;
